import { Info } from "lucide-react";
import { useRef, useState } from "react";

interface TooltipType {
    text: string;
    info?: React.ReactNode;
    position?: "up" | "down" | "left" | "right";
}

const Tooltip = ({ text, info, position = "down" }: TooltipType) => {
    const [showContent, setShowContent] = useState<boolean>(false);
    const tooltipRef = useRef<HTMLDivElement>(null);

    return (
        <div className="relative">
            <div
                ref={tooltipRef}
                className="inline-block relativee"
                onMouseEnter={() => setShowContent(true)}
                onMouseLeave={() => setShowContent(false)}
            >
                <span className="cursor-pointer">
                    {info ?? <Info size={15} />}
                </span>
                {showContent && (
                    <div
                        className={`
                            bg-gray-200 text-secondary p-2 font-light text-[13px] absolute z-20 min-w-[15em]
                            ${position === "up" ? "bottom-full mb-2" : ""}
                            ${position === "down" ? "top-full mt-2" : ""}
                            ${position === "left" ? "right-full mr-2 top-1/2 -translate-y-1/2" : ""}
                            ${position === "right" ? "left-full ml-2 top-1/2 -translate-y-1/2" : ""}
                        `}
                        style={{ boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px" }}
                    >
                        {text}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Tooltip;
